
<div id="recaptcha-container">
    <div id="grecaptcha"></div>
    <div class="reset-container" v-if="resetOption">
        <button @click="resetRecaptcha()">¿reCAPTCHA no funciona? Reiniciar</button>
    </div>
</div>
